// extracted by mini-css-extract-plugin
export default {"root":"tile-module--root--47b55","image":"tile-module--image--5bc0d","title":"tile-module--title--817f6","arrow":"tile-module--arrow--f6895"};